<div class="custom-date-time-picker"
    [ngClass]="{'disabled': isDisabled, 'submitted': formSubmitted, 'focus': inputFocused}">
    <button type="button" class="picker-icon-button" [disabled]="isDisabled" (click)="dp.toggle()"
        [attr.aria-expanded]="dp.isOpen" [attr.data-automation-id]="automationId + 'calendar-button'">
        <i class="fa fa-calendar calendar-icon"></i>
    </button>
    <input class="picker-input" type="text" [disabled]="isDisabled" (input)="onInput($event)"
        (focus)="onPickerInputFocus(true)" (focusout)="onPickerInputFocus(false)" [placeholder]="inputPlaceholder"
        [attr.name]="isFormControl? 'datepickerinput':''" #dp="bsDatepicker" bsDatepicker [(ngModel)]="dateValue"
        (ngModelChange)="onDateChange()" (bsValueChange)="onDateChange()" (onHidden)="onDateChange()"
        (onShown)="clearErrorPopover()" [attr.data-automation-id]="automationId + '-input'" [bsConfig]="pickerConfig"
        [isDateRange]="isDateRange" [hasErrorMessage]="hasErrorMessage" [isStart]="isStart" [isEnd]="isEnd" />
    <button type="button" [hidden]="!showClearButton || isDisabled" class="picker-icon-button" (click)="onClearClick()"
        [disabled]="isDisabled" [attr.data-automation-id]="automationId + 'clear-button'">
        <i class="fa fa-times"></i>
    </button>
</div>
<span class="error-popover" [style.margin-left]="isStart ? '137px' : '132px'" containerClass="error" container="body"
    [popover]="errorPopoverTemplate" triggers="" #errorPopover="bs-popover" placement="bottom"></span>
<ng-template #errorPopoverTemplate><span
        [attr.data-automation-id]="automationId + '-error-label'">{{pickerError}}</span><i class="fa fa-close"
        (click)="errorPopover.hide()"></i></ng-template>